module.exports = __webpack_public_path__ + "img/pushProcurement_bg.9bb97807.png";